import classNames from "classnames";
import Image from "./Image";

export default function LogoGrid({
  logos,
  andMore,
  sixUp,
  noBorders,
  imgPath,
}) {
  if (logos.length === 6) {
    sixUp = true;
  }

  return (
    <div className="max-w-screen-xl mx-auto py-12 px-6 sm:px-6 lg:px-8">
      <div
        // md:grid-cols-6 md:grid-cols-5
        class={`grid grid-cols-2 gap-4 sm:gap-8 sm:grid-cols-3 md:grid-cols-${
          sixUp ? 6 : 5
        } ${!noBorders && "opacity-75"}`}
      >
        {logos.map(({ asset, label }) => (
          <div
            key={asset}
            className={classNames(
              noBorders
                ? "h-full"
                : `h-32 p-6 sm:h-40 lg:h-${sixUp ? 40 : 48}`,
              `sm:p-4 col-span-1 flex justify-center items-center lg:col-span-1`,
              !noBorders && "bg-white shadow-md rounded-lg ",
              [
                "a24",
                "smithsonian",
                "stl",
                "longbeach",
                "indiememphismain",
              ].includes(asset) && "sm:p-8"
            )}
          >
            <Image
              className={`max-h-${!noBorders ? "20" : "80"} sm:max-h-${!noBorders ? "20" : "80"}`}
              src={
                imgPath
                  ? imgPath + `${asset}.png`
                  : `/images/logos/${asset}.png`
              }
              alt={label}
            />
          </div>
        ))}
        {andMore ? (
          <div className="flex justify-center items-center md:col-span-2 font-medium text-xs md:text-lg italic p-4">
            ...and 100s more of the most forward-thinking organizations in the
            world of independent film.
          </div>
        ) : null}
      </div>
    </div>
  );
}
